module.exports = __webpack_public_path__ + "static/media/person_white.02394a69.png";